document.addEventListener('DOMContentLoaded', () => {
  class SubscriptionAgreement extends HTMLElement {
    constructor() {
      super();
      this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
      this.handleSubmitClick = this.handleSubmitClick.bind(this);
    }

    connectedCallback() {
      // Create a change event listener for a change on 'agree-subscription' checkbox element
      const checkbox = this.querySelector('#agree-subscription');
      if (checkbox) {
        checkbox.addEventListener('change', this.handleCheckboxChange);
      }

      // Add event listener to the submit button
      const submitButton = document.querySelector('.cart-checkout-button');
      if (submitButton) {
        submitButton.addEventListener('click', this.handleSubmitClick);
      }
    }

    handleCheckboxChange(event) {
      // Find the submit button and remove disabled state if the checkbox is checked and re-add it if it is unchecked
      const submitButton = document.querySelector('.cart-checkout-button');
      if (submitButton) {
        if (event.target.checked) {
          submitButton.classList.remove('disabled');
        } else {
          submitButton.classList.add('disabled');
        }
      }
    }

    handleSubmitClick(event) {
      console.log('Submit button clicked');
      const checkbox = this.querySelector('#agree-subscription');
      if (checkbox && !checkbox.checked) {
        event.preventDefault(); // Prevent form submission
        alert('Please agree to the subscription terms before proceeding.');
      }
    }
  }

  // Define the custom element
  customElements.define('subscription-agreement', SubscriptionAgreement);
});
